import React, { useRef } from 'react';
var VeltAutocompleteOptionName = function (props) {
    var children = props.children;
    var ref = useRef(null);
    return (React.createElement("velt-autocomplete-option-name", { ref: ref }, children));
};
export default VeltAutocompleteOptionName;
